import { render } from "./GuaView.vue?vue&type=template&id=68c8bdc6&scoped=true&ts=true"
import script from "./GuaView.vue?vue&type=script&lang=ts"
export * from "./GuaView.vue?vue&type=script&lang=ts"

import "./GuaView.vue?vue&type=style&index=0&id=68c8bdc6&scoped=true&lang=scss"

import exportComponent from "E:\\vue-next\\divination_by_coin\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-68c8bdc6"]])

export default __exports__